/**
 * @typedef {ResolvedValue}
 *
 * This is the type of all values returned by `lookup()`. They may
 * NOT contain ANY `Reference` or `EmbeddedValue` or
 * `ConstructableContainer` objects. All such values will be resolved
 * to their plain form before being returned to you. They represent
 * the fully realized snapshot of related objects in the store for
 * the current state.
 *
 * It can be any type at all, including primitives and is meant to be
 * used inside `connect()`` to be passed on as React prop values.
 *
 * Resolved values do not know any of their storage details and
 * cannot be returned to the store. They are only intended for use
 * in rendering.
 */

/**
 * @typedef {ReferenceValue}
 *
 * Reference values are the internal storage format of the cache. They
 * are not exposed during normal operation (but they can be used
 * to optimistically re-compose values for requests that support
 * this).
 *
 * They can be any value (including primitives) but cannot contain
 * `EmbeddedValue` or instantiated container objects. They CAN contain
 * `ConstructableContainer` and `Reference` objects however.
 *
 * They represent the canonical, denormalized state of data in the
 * store, but must be resolved with actual instances before they can
 * be used.
 */


export {default as BasicData} from './BasicData';
export {default as container} from './container';
export {default as embedded} from './embedded';
export {default as lookupMeta} from './lookupMeta';
export {default as lookup} from './lookup';
export {default as makeRequester} from './makeRequester';
export {default as makeRequest} from './makeRequest';
export {default as forceRequestData} from './forceRequestData';
export {default as reference} from './reference';
export {default as requestData} from './requestData';

export {default as reduceDataCaches} from './storage/reduceDataCaches';

export {default as accumulateClientEvent} from './fetching/accumulateClientEvent'; // Deprecated
export {default as clientFetch} from './fetching/clientFetch'; // Deprecated

export {default as forever} from './caching/forever';
export {default as noCache} from './caching/noCache';
export {default as timedExpiration} from './caching/timedExpiration';

export {default as addDependentRequests} from './streams/addDependentRequests';
export {default as clientRequestStream} from './streams/clientRequestStream';
export {default as p4RelayRequestStream} from './streams/p4RelayRequestStream';



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/index.js